import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UserCommonService } from '../../services/user-common.service';
import { UiService } from '../../services/ui.service';
import { AppSettings } from '../../app.settings';
import { ErrorBindingService } from '../../services/error-binding.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {

  @Input() userId: String;
  @Input() type = 'driver';
  @Output() closePasswordDialog: EventEmitter<any> = new EventEmitter();
  @Output() closeSuccessUpdatePassword: EventEmitter<any> = new EventEmitter();
  setPasswordForm: UntypedFormGroup;
  inputType = 'password';
  cnfInputType = 'password';
  @Input() isShuttle = false;
  changePasswordErrors:any[] = [
    {
      newPassword: false,
      newConfirmPassword: false,
    }
  ];
  constructor(
    private formBuilder: FormBuilder,
    private userCommonService: UserCommonService,
    private uiService: UiService,
    private commonService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService
  ) { }

  ngOnInit() {
    this.setPasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS)]],
      newConfirmPassword: ['', [Validators.required, Validators.minLength(8),
      Validators.pattern(AppSettings.PASSWORD_VALIDATIONS), this.passwordMatchValidator()]]
    });

    this.subscribePasswordMatchValidation();
  }

  private subscribePasswordMatchValidation(): void {
    const confirmControl = this.setPasswordForm.get('newConfirmPassword');
    const revalidateConfirmPassword = () => {
      confirmControl?.updateValueAndValidity({ emitEvent: false });
    };

    this.setPasswordForm.get('newPassword')?.valueChanges.subscribe(revalidateConfirmPassword);
    this.setPasswordForm.get('newConfirmPassword')?.valueChanges.subscribe(revalidateConfirmPassword);
  }

  showPasswordMismatchError(): boolean {
    const newPasswordControl = this.setPasswordForm?.get('newPassword');
    const confirmPasswordControl = this.setPasswordForm?.get('newConfirmPassword');

    if (!newPasswordControl || !confirmPasswordControl) {
      return false;
    }

    const newPassword = newPasswordControl.value;
    const confirmPassword = confirmPasswordControl.value;
    const fieldsTouched = newPasswordControl.dirty || newPasswordControl.touched
      || confirmPasswordControl.dirty || confirmPasswordControl.touched;

    return fieldsTouched && !!newPassword && !!confirmPassword && newPassword !== confirmPassword;
  }

  private passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent || !control.value) {
        return null;
      }

      const newPassword = control.parent.get('newPassword')?.value;
      return newPassword === control.value ? null : { passwordMismatch: true };
    };
  }

  passwordNotMatched() {
    if (this.setPasswordForm.controls.newPassword.value !== this.setPasswordForm.controls.newConfirmPassword.value) {
      const error = {
        general: [
          {
            message: this.commonService.getLabel('error_new_confirm_password_not_match')
          }
        ]
      };
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.errorBindingService.onAPIValidationError(error, this.changePasswordErrors);
    } else {
      return true;
    }
  }

  requestData() {
    return {
      password: this.setPasswordForm.controls.newPassword.value,
    };
  }

  doChangePassword() {
    const passwordVerified = this.passwordNotMatched();

    if (passwordVerified) {
      const data = this.requestData();
      if(this.isShuttle) {
        this.userCommonService.updatePasswordShuttleDriver(JSON.stringify(data), this.userId).subscribe(results => {
          if (results.general !== null && results.general !== undefined) {
            results.general.forEach(element => {
              this.uiService.showMessage(element.message, AppSettings.MESSAGE_TYPE.SUCCESS);
            });
            this.setPasswordForm.reset();
            setTimeout(() => {
              this.onSuccess();
            }, 500);
          }
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        }); 
      } else {
        this.userCommonService.updatePassword(JSON.stringify(data), this.userId).subscribe(results => {
          if (results.general !== null && results.general !== undefined) {
            results.general.forEach(element => {
              this.uiService.showMessage(element.message, AppSettings.MESSAGE_TYPE.SUCCESS);
            });
            this.setPasswordForm.reset();
            setTimeout(() => {
              this.onSuccess();
            }, 500);
          }
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        });  
      }
    }

  }

  tooglePasswordType() {
    if (this.inputType === 'password') {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  toogleCnfPasswordType() {
    if (this.cnfInputType === 'password') {
      this.cnfInputType = 'text';
    } else {
      this.cnfInputType = 'password';
    }
  }

  onCancel() {
    this.setPasswordForm.reset();
    this.closePasswordDialog.emit(false);
  }

  onSuccess() {
    this.setPasswordForm.reset();
    this.closeSuccessUpdatePassword.emit(true);
  }

}
